'use client';
var buttonStylesReset = {
    WebkitTapHighlightColor: "transparent",
    background: "transparent",
    // Отключение focusRing.
    outline: 0,
    border: 0,
    margin: 0,
    borderRadius: 0,
    padding: 0,
    MozAppearance: "none",
    WebkitAppearance: "none",
    "&::-moz-focus-inner": {
        borderStyle: "none"
    },
    textDecoration: "none"
};

export { buttonStylesReset };
